import RouteView from "../../../Routes/RouteView";
import TaskNavOptions, {defaultRoute} from "./TaskNavOptions";
const Tasks=({navoption, ModalAction})=>{
    return(
        <RouteView defaultRoute={defaultRoute} ModalAction={ModalAction} navoption={navoption} >{TaskNavOptions}</RouteView>
    )
}
export default Tasks;